import React from 'react';
const KeywordsResearchDeleteIcon = () => {
  return <svg xmlns="http://www.w3.org/2000/svg" width="14" height="15" viewBox="0 0 14 15" fill="none">
  <path d="M5 1.99388C5 0.892691 5.89543 0 7 0C8.10457 0 9 0.892691 9 1.99388H13C13.5523 1.99388 14 2.44023 14 2.99082C14 3.54142 13.5523 3.98776 13 3.98776H1C0.447716 3.98776 0 3.54142 0 2.99082C0 2.44023 0.447715 1.99388 1 1.99388H5Z" fill="#5C5F62"/>
  <path d="M2 12.5076V6H4V12.5076C4 12.7829 4.22386 13.0061 4.5 13.0061H6V6H8L8 13.0061H9.5C9.77614 13.0061 10 12.7829 10 12.5076V6H12V12.5076C12 13.8841 10.8807 15 9.5 15H4.5C3.11929 15 2 13.8841 2 12.5076Z" fill="#5C5F62"/>
  </svg>
};

export default KeywordsResearchDeleteIcon;